import React, { Component } from "react";
import Hero from "./../../components/hero";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import { Colors } from "./../../utils/variables";
import FAQ from "./../../components/faq";
import SkillsClinicsSection from "./../../components/skillsClinicsSection";
import clinicsData from "./../../data/skillsClinics.json";
import "./get-ready.scss";

const CARD_BG_STYLE = {
  backgroundImage: "url(/images/topo-texture.png)",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const PACK_LIST = [
  "Bike in good working order",
  "Helmet",
  "Riding clothes & layers",
  "Rain gear",
  "Sunscreen & lip balm",
  "Water bottles / hydration",
  "Snacks",
  "Personal toiletries",
  "Sleeping gear (if camping)",
  "Headlamp or flashlight",
];

const CHECKLIST_ITEMS = [
  { id: 1, label: "Buy your Free to Roam ticket", type: "link", to: "/register", registerButton: true, hideRegisterLink: true },
  { id: 2, label: "Choose Your Stay (Optional)", type: "content", contentKey: "stay" },
  { id: 3, label: "Register for additional clinics", type: "content", contentKey: "clinics" },
  { id: 4, label: "Pack list", type: "content", contentKey: "pack" },
  { id: 5, label: "Review FAQs", type: "content", contentKey: "faq" },
];

function GetReadyCard({ number, label, children, linkTo, linkLabel = "Go", registerButton = false, hideRegisterLink = false, cardClassName = "" }) {
  const cardHeader = (
    <div className="get-ready-card-header">
      <span className="get-ready-number">{number}</span>
      <h3 className="get-ready-card-title">{label}</h3>
      {registerButton && linkTo && (
        <a href={linkTo} target="_blank" rel="noopener noreferrer" className="get-ready-card-header-button">
          <span className="card-button button" style={{ color: Colors.white, backgroundColor: Colors.tertiary }}>
            Register
          </span>
        </a>
      )}
    </div>
  );

  if (linkTo && registerButton) {
    return (
      <div className={`get-ready-card shadow get-ready-card--header-only${hideRegisterLink ? " get-ready-card--hide-register-link" : ""} ${cardClassName}`.trim()} style={CARD_BG_STYLE}>
        {cardHeader}
      </div>
    );
  }

  if (linkTo && !registerButton) {
    return (
      <div className="get-ready-card shadow" style={CARD_BG_STYLE}>
        {cardHeader}
        <div className="get-ready-card-body">
          <a href={linkTo} target="_blank" rel="noopener noreferrer" className="get-ready-card-link">
            <span className="card-button button" style={{ color: Colors.white, backgroundColor: Colors.tertiary }}>
              {linkLabel}
            </span>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="get-ready-card shadow" style={CARD_BG_STYLE}>
      {cardHeader}
      <div className="get-ready-card-body get-ready-card-body--content">
        {children}
      </div>
    </div>
  );
}

export default class GetReady extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div className="light-grey-background get-ready-page" style={{ backgroundColor: Colors.primaryDark }}>
        <div className="slant-bottom">
          <Hero
            title="Get Ready"
            subtitle="Your weekend checklist"
            backgroundImage="/images/get-ready-hero.jpg"
            height="threequarter"
            tint=""
          />
        </div>

        <ScrollFadeIn>
          <div
            className="get-ready-section lip large-padding"
          >
            <div className="medium-max-width-container get-ready-cards">
              {CHECKLIST_ITEMS.map((item) =>
                item.type === "link" ? (
                  <GetReadyCard key={item.id} number={item.id} label={item.label} linkTo={item.to} registerButton={item.registerButton} hideRegisterLink={item.hideRegisterLink} />
                ) : (
                  <GetReadyCard key={item.id} number={item.id} label={item.label}>
                    {item.contentKey === "stay" && (
                      <div className="get-ready-stay-options">
                        <a href="/camping" target="_blank" rel="noopener noreferrer" className="get-ready-stay-option">
                          <span className="get-ready-stay-option-label">Camping</span>
                          <span className="material-icons get-ready-stay-option-icon">open_in_new</span>
                        </a>
                        <a href="/lodging" target="_blank" rel="noopener noreferrer" className="get-ready-stay-option">
                          <span className="get-ready-stay-option-label">Kirkwood Lodging</span>
                          <span className="material-icons get-ready-stay-option-icon">open_in_new</span>
                        </a>
                      </div>
                    )}
                    {item.contentKey === "pack" && (
                      <ul className="get-ready-pack-list" style={{ color: Colors.white }}>
                        {PACK_LIST.map((entry, i) => (
                          <li key={i}>
                            <span className="material-icons get-ready-pack-icon">check_circle</span>
                            {entry}
                          </li>
                        ))}
                      </ul>
                    )}
                    {item.contentKey === "faq" && (
                      <div className="get-ready-faq-inner">
                        <FAQ showTitle={false} />
                      </div>
                    )}
                    {item.contentKey === "clinics" && (
                      <div className="get-ready-clinics-inner get-ready-clinics-inner--hide-datetime">
                        <SkillsClinicsSection
                          data={clinicsData}
                          variant="condensed"
                          showSectionHeader={false}
                          showRegisterButton={false}
                          cardBackgroundColor={Colors.primaryDark}
                        />
                      </div>
                    )}
                  </GetReadyCard>
                )
              )}
            </div>
          </div>
        </ScrollFadeIn>
      </div>
    );
  }
}
